import styled from 'styled-components';
import { PrimaryButton, TextButton } from '@prisjakt/ui/button/variants';
import { IconCheckFilled } from '@prisjakt/ui/icon/check-filled';

export const FeatureList = styled.ul`
  list-style: none;
  margin: 10px 0 20px 0;
`;

export const FeatureListItem = styled.li`
  padding: 10px;
`;

export const FeatureListCheckIcon = styled(IconCheckFilled)`
  vertical-align: middle;
  margin-right: 0.5em;
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  width: 100%;
  text-align: center;
`;

export const StyledTextButton = styled(TextButton)`
  margin-top: 10px;
  margin-bottom: 5px;
  width: 100%;
  text-align: center;
`;
